import 'whatwg-fetch';
import 'devextreme/data/odata/store';
//import DataGrid, { Column, Paging, Pager, FilterRow } from 'devextreme-react/data-grid';
import { PivotGrid, PivotGridTypes, Scrolling, } from 'devextreme-react/pivot-grid';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import SelectBox from 'devextreme-react/select-box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import lookupservice from '@/projects/platform/services/lookup-service';
import { DateBox } from 'devextreme-react';
import { FilterDescriptor } from 'devextreme/data';
import { useState } from 'react';
import { reatiler } from '@/core/utils/report-datas';


import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import { Config } from '@/core/config/config';
import { extFormatDate } from '@/core/helper/date-helper';
import { httpHeaderHelper } from '@/core/helper/http-header';

const currentDate = new Date()
const startDate = new Date(currentDate.getFullYear(), 0, 1)
const endDate = new Date(currentDate.getFullYear() + 1, 0, 0)


var isFirst = true;
var store = createStore({
    loadUrl: `${Config.VITE_APP_GATEWAY_URL}/api/report/internal-report/sales-performance-grid-report-two`,
    onBeforeSend: (e, ajaxOptions) => {
        ajaxOptions.method = 'GET';
        ajaxOptions.cache = true;
        ajaxOptions.headers = httpHeaderHelper.httpHeader;
        if (isFirst) {
            filter = filter.length === 0 ? getDefaultFilterValues() : filter;
            isFirst = false;
            ajaxOptions.url += `?filter=${JSON.stringify(filter)}`
        }
    }
});




function formatCurrency(arg: any) {
    return arg.value ? new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(arg.value) : "";
}

const dataSource = new PivotGridDataSource({
    remoteOperations: true,
    store,
    fields: [{
        caption: 'Product Group',
        dataField: 'ProductGroup',
        width: 250,
        area: "row"
    },
    {
        caption: 'Sub Product Group',
        dataField: 'SubProductGroup',
        width: 250,
        area: "row"
    },
    {
        caption: 'Product',
        dataField: 'Product',
        width: 250,
        area: "row"
    },
    {
        caption: "Retailer",
        dataField: "Retailer",
        area: "column",
    },
    {
        caption: "Sales Date",
        dataField: "SalesDate",
        area: "filter",
        dataType: "date",
        format: {
            type: "shortDate"
        }
    },
    {
        caption: 'Sales Amount',
        dataField: 'SalesAmount',
        customizeText: formatCurrency,
        format: {
            type: "currency",
            precision: 2
        },
        summaryType: 'sum',
        area: "data",
        showGrandTotals: false,
    },
    {
        caption: 'Sales Qty',
        dataField: 'SalesQuantity',
        summaryType: 'sum',
        area: "data",
        format: {
            type: "fixedPoint"
        },
        showGrandTotals: false,

    },
    {
        caption: 'Average Sales Price',
        format: {
            type: "currency",
            precision: 2
        },
        customizeText: formatCurrency,
        summaryType: 'avgSales',
        area: "data",
        dataType: 'number',
        showGrandTotals: false,
    }]
});

function getDefaultFilterValues() {

    addToFilterArray(filter, 'StartDate', '>=', extFormatDate(startDate));
    addToFilterArray(filter, 'EndDate', '<=', extFormatDate(endDate));
    return filter;
}

var filter: Array<FilterDescriptor> = [];
function addToFilterArray(filter: Array<FilterDescriptor>, key: any, operator: any, value: any) {
    const existingIndex = filter.findIndex((item: any) => item[0] === key);
    if (existingIndex !== -1) {
        filter.splice(existingIndex, 1);
        if (existingIndex === filter.length)
            filter.splice(existingIndex - 1, 1);
        else
            filter.splice(existingIndex, 1);
    }
    if (value) {
        if (filter.length > 0) {
            filter.push("AND");
        }

        filter.push([key, operator, value]);
    }

}

export default function SalesPerformanceGridReportReportTwo() {


    const [productGroups, setProductGroups] = useState<any>([]);

    function onSubProductValueChanged(e: any) {
        addToFilterArray(filter, 'ProductGroup', '=', e.value ?? undefined);
        dataSource.filter(filter);
        dataSource.load();
    }

    function onRetailerValueChanged(e: any) {
        var item = reatiler.find(item => item.Value === e.value)
        addToFilterArray(filter, 'Retailer', '=', item ? item.Text : undefined);
        dataSource.filter(filter);
        dataSource.load();
    }

    function onStartDateValueChanged(e: any) {
        addToFilterArray(filter, 'StartDate', '>=', extFormatDate(e.value));
        dataSource.filter(filter);
        dataSource.load();
    }
    function onEndDateValueChanged(e: any) {

        addToFilterArray(filter, 'EndDate', '<=', extFormatDate(e.value));
        dataSource.filter(filter);
        dataSource.load();
    }



    function getProductGroups() {
        return lookupservice.getProductGroupLookup({})
            .then((response) => (
                setProductGroups(response.data)
            ))
            .catch(() => { throw new Error('Data Loading Error'); });
    }
    useState(() => {

        getProductGroups();
        var defaulFilter = getDefaultFilterValues();
        dataSource.filter(defaulFilter);
    })




    return (
        <>
            <Row>
                <h5 className="text-center m-10">Retailer Comparison Report</h5>
            </Row>
            <Row>
                <Col md={1}></Col>
                <Col md={2}>
                    <Form.Label htmlFor="productGroups">Product Group</Form.Label>
                    <SelectBox
                        name='productGroups'
                        showClearButton={true}
                        dataSource={productGroups}
                        // defaultValue={productGroups[0].Value}
                        valueExpr="value"
                        displayExpr="text"
                        onValueChanged={onSubProductValueChanged}
                    />
                </Col>
                <Col md={2}>
                    <Form.Label htmlFor="retailers">Retailers</Form.Label>
                    <SelectBox
                        name='retailers'
                        showClearButton={true}
                        dataSource={reatiler}
                        // defaultValue={reatiler[0].Value}
                        valueExpr="Value"
                        displayExpr="Text"
                        onValueChanged={onRetailerValueChanged}
                    />
                </Col>
                <Col md={3}>
                    <Form.Label htmlFor="startDate">Start Date</Form.Label>
                    <DateBox
                        value={startDate}
                        name='startDate'
                        type="date"
                        onValueChanged={onStartDateValueChanged}
                    />
                </Col>
                <Col md={3}>
                    <Form.Label htmlFor="endDate">End Date</Form.Label>
                    <DateBox
                        value={endDate}
                        name='endDate'
                        type="date"
                        onValueChanged={onEndDateValueChanged}
                    />
                </Col>
                <Col md={1}></Col>
            </Row>
            <br></br>
            <PivotGrid
                className={'dx-card wide-card'}
                allowSorting={true}
                allowSortingBySummary={true}
                allowFiltering={false}
                fieldChooser={{
                    enabled: false
                }}
                showBorders={true}
                rowHeaderLayout="tree"
                showRowGrandTotals={false}
                dataSource={dataSource}>

                <Scrolling mode="virtual" />
            </PivotGrid>
            <Row>
                <Col md={1}></Col>
                <Col md={10}>
                </Col>

                <Col md={1}></Col>
            </Row>
        </>
    );
}
